function normalizeSpeech(text) {
  return String(text || '')
    .toLowerCase()
    .replace(/[\u2018\u2019\u201A\u201B`´']/g, '')
    .replace(/[\u201C\u201D]/g, ' ')
    .replace(/[.,!?":;()[\]]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

const TRAIL = '(?: please| now| yeah| yup| thanks)?';

const NEXT_END = [
  new RegExp(`(?:that is|thats|that s) all(?: for now)?${TRAIL}$`),
  new RegExp(`(?:i am|im|i m) done with (?:my |the )?answers?${TRAIL}$`),
];

const SKIP_END = [
  new RegExp(`(?:please |can you )?(?:skip|pass) (?:this|the) question${TRAIL}$`),
];

function cueChunks(text) {
  const t = normalizeSpeech(text);
  if (!t) return [];
  const words = t.split(' ').filter(Boolean);
  const chunks = [t];
  if (words.length > 8) chunks.push(words.slice(-8).join(' '));
  return [...new Set(chunks)];
}

function endsWithAny(text, patterns) {
  return patterns.some((re) => re.test(text));
}

/** 'skip' | 'next' | null — matches a spoken end/skip command. */
export function detectAdvanceCue(text) {
  const chunks = cueChunks(text);
  if (!chunks.length) return null;
  for (const chunk of chunks) {
    if (endsWithAny(chunk, SKIP_END)) return 'skip';
  }
  for (const chunk of chunks) {
    if (endsWithAny(chunk, NEXT_END)) return 'next';
  }
  return null;
}

export function stripAdvanceCue(text) {
  let out = String(text || '').trim();
  if (!out) return '';
  const patterns = [
    /(?:that is|that's|thats|that s)\s+all(?:\s+for now)?[.!?]*$/i,
    /(?:i am|i'm|im|i m)\s+done with (?:my |the )?answers?[.!?]*$/i,
    /(?:please\s+|can you\s+)?(?:skip|pass)\s+(?:this|the)\s+question[.!?]*$/i,
  ];
  patterns.forEach((re) => {
    out = out.replace(re, '').trim();
  });
  return out.replace(/\s+/g, ' ').trim();
}
